import { useEffect } from 'react';
import { trackEvent } from '../../services/analyticsService';
import { EVENTS, sessionStartedProps } from './utils/events';
import packageJson from '../../../package.json';

export const AnalyticsProvider = ({ children }) => {
  useEffect(() => {
    trackEvent(EVENTS.SESSION_STARTED, sessionStartedProps({
      platform: 'web',
      appVersion: packageJson.version
    }));
  }, []);

  return children;
};
